import React from "react";
import PropTypes from "prop-types";
import { Text } from "@kui/foundations-react";
import { HorizontalLogo } from "@kui/foundations-react/Logo";

// Card header of the Figma RWA frames: logo, title, help line and (optional) PAK ID
const RegHeader = (props) => {
  return (
    <header className='regHeader'>
      <div className='regHeaderLogo'>
        <HorizontalLogo role='img' aria-label='NVIDIA' />
      </div>
      {props.title && (
        <Text kind='title/md' asChild>
          <h1 className='regHeaderTitle'>{props.title}</h1>
        </Text>
      )}
      {props.helpLink && (
        <Text kind='body/regular/md' asChild>
          <p className='regHeaderHelp'>
            If you need assistance or have questions with account registration,
            please review Registration{" "}
            <a href={props.helpLink} target='_blank' rel='noopener noreferrer'>
              FAQ
            </a>
          </p>
        </Text>
      )}
      {props.pakId && (
        <Text kind='mono/md' asChild>
          <p className='regHeaderPak'>PAK ID: {props.pakId}</p>
        </Text>
      )}
    </header>
  );
};

RegHeader.propTypes = {
  title: PropTypes.string,
  helpLink: PropTypes.string,
  pakId: PropTypes.string,
};

export default RegHeader;
